module.exports = __webpack_public_path__ + "img/DIO3000_R.5ae426e9.png";